module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-left",
    attrs: {
      "type": "button",
      "aria-controls": "navbarNavAltMarkup",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    },
    on: {
      "click": _vm.closeNav
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "cursor": "pointer"
    }
  }, [_vm._v("☰")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "closebtn",
    on: {
      "click": _vm.closeNav
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default fixed-top navbar-inverse",
    attrs: {
      "role": "navigation",
      "id": "applicationbrandbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse",
    attrs: {
      "id": "navbarNavAltMarkup"
    }
  }, [_vm._l((_vm.navItems), function(navItem) {
    return _c('ul', {
      staticClass: "nav navbar-nav"
    }, [_c('li', {
      staticClass: "nav-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: navItem.name,
          query: navItem.query
        },
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm.user_lang.myprofile))])], 1), _vm._v(" "), (_vm.isAdmin === 'superadmin' || _vm.isAdmin === 'admin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "adminLink",
        "to": _vm.adminItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm.user_lang.adminLabel))])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "tmLink",
        "to": _vm.tmItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("Configuration")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "apisetLink",
        "to": _vm.apisetItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("API Settings")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin === 'superadmin') ? _c('li', {
      staticClass: "nav-item",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [_c('router-link', {
      attrs: {
        "id": "emailLogLink",
        "to": _vm.emailLogItem.to,
        "active-class": "activeHeader",
        "exact": ""
      }
    }, [_vm._v("Email Logs")])], 1) : _vm._e()])
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav-admin ml-auto"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "2px solid var(--theme-secondary)"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lang),
      expression: "lang"
    }],
    staticClass: "lang-dpd",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeUserLang]
    }
  }, _vm._l((_vm.lang_def), function(i) {
    return _c('option', {
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  })), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v dots",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal",
      "data-target": ".bs-example-modal-sm",
      "data-placement": "bottom",
      "title": "",
      "role": ""
    }
  }, [_c('div', {
    staticClass: "help-div"
  }, [_vm._v(" " + _vm._s(_vm.user_lang.logout) + " ")])])])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "var(--theme-primary)"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.logout) + " "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('center', [_vm._v(_vm._s(_vm.user_lang.logoutConfirm))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  }, [_c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    staticStyle: {
      "background-color": "#ececec",
      "color": "#000"
    },
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "border-top": "0",
      "padding-top": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "id": "loggout",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.oktaSignOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0px 25px"
    }
  }, [_c('a', {
    staticClass: "navbar-brand",
    staticStyle: {
      "padding-right": "5rem"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "internal-logo",
    staticStyle: {
      "padding": "0rem",
      "max-width": "160px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "src": require("../../../assets/img/logo-cargillwhite-help.svg"),
      "height": "45px"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c862efd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c862efd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/brandBar/brandBar.vue
// module id = 704
// module chunks = 1